@use '../../../../../../styles/Colors.scss' as Colors;
@use '../../../../../../styles/Constants.scss' as Constants;
@use '../../../../../../components/Table/styles.module.scss' as Table;

$var-shadow: 0 2px 2px 0 Colors.$col-shadow;
$var-submit-action-top-offset: -16px;
$var-tabs-navigation-top-offset: 48px;

.invoice {

	&__table-header {
		font-size: Constants.$val-fontSizeSmall;

		&>span {
			text-transform: uppercase;
		}

		&>b {
			margin-left: Constants.$val-spacing-xs;
			margin-right: Constants.$val-spacing-l;
		}
	}

	&__sub-row-cell {
		color: Colors.$col-greyFontLight;
	}

	&__no-billing-code {
		color: Colors.$col-greyFontLight;
		font-style: italic;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
	}

	&__empty-cell {
		color: Colors.$col-greyFontLight;

		&--right-aligned {
			display: flex;
			justify-content: flex-end;
			width: 100%;
		}
	}

	&__status-cell {
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;

		&--draft {
			[class^="icon-draft"] {
				margin-right: Constants.$val-spacing-s;
				color: Colors.$col-design-gray6;
			}
		}

		&--invoiced {
			[class^="icon-invoice_status_invoiced"] {
				margin-right: Constants.$val-spacing-s;
				color: Colors.$col-orange;
			}
		}

		&--partially-paid {
			[class^="icon-check"] {
				margin-right: Constants.$val-spacing-s;
				color: Colors.$col-darkBlueBorder;
				font-weight: bold;
			}
		}

		&--paid {
			[class^="icon-check"] {
				margin-right: Constants.$val-spacing-s;
				color: Colors.$col-green;
				font-weight: bold;
			}
		}

		&--overpaid {
			[class^="icon-check"] {
				margin-right: Constants.$val-spacing-s;
				color: Colors.$col-red;
				font-weight: bold;
			}
		}

		&--sub-row-cell {
			color: Colors.$col-greyFontLight;
		}

		&>b {
			white-space: nowrap;
			text-overflow: ellipsis;
			overflow: hidden;
		}
	}

	.table-container__table__body {
		height: calc(100vh - Table.$var-company-header-height - Table.$var-breadcrumbs-header-height - Table.$var-tabs-navigation-height - Table.$var-table-header-height - Table.$var-table-action-header-height - Table.$var-table-footer-height - 4 * Constants.$val-spacing-xl - 6 * Constants.$val-spacing-m);
	}
}

.invoice-form {

	&__submit-section {
		display: flex;
		align-items: end;
		background-color: Colors.$col-white;
		padding: Constants.$val-spacing-m Constants.$val-spacing-l;
		z-index: 3;
		border-bottom: 1px solid #C5C8CB;
		top: $var-submit-action-top-offset;
		position: sticky;

		&__invoice-code-and-reminder {
			font-size: Constants.$val-fontSizeBig;
			font-weight: bold;
			flex: 1;
			display: flex;

			&__code {
				padding-right: Constants.$val-spacing-l;
				align-content: center;
			}
		}
	}

	&__tabs-navigation {
		position: sticky;
		top: $var-tabs-navigation-top-offset;
		z-index: 3;
	}

	&__tab-content {
		display: flex;
		flex-direction: column;
		gap: Constants.$val-spacing-m;
		margin-top: Constants.$val-spacing-s;

		&__form {
			background-color: #FAFAFA;			

			&__section {
				background-color: Colors.$col-white;
				box-shadow: $var-shadow;
				padding: Constants.$val-spacing-m Constants.$val-spacing-l;
				margin-top: Constants.$val-spacing-m;
				margin-bottom: Constants.$val-spacing-m;
				margin-left: Constants.$val-spacing-s;
				margin-right: Constants.$val-spacing-s;
	
				&__title {
					text-transform: uppercase;
					color: Colors.$col-design-gray5;
					font-size: Constants.$val-fontSizeSmall;
					margin-bottom: Constants.$val-spacing-m;
				}

				&__installment-notice {
					font-style: italic;
					color: Colors.$col-design-gray5;
					margin-bottom: Constants.$val-spacing-m;
				}
	
				&__row {
					display: grid;
					margin-bottom: Constants.$val-spacing-m;
					gap: Constants.$val-spacing-l;
					grid-template-columns: repeat(8, 1fr);

					&__column-date {
						grid-column: span 2;

						> div {
							width: 60%;
						}
					}
	
					&__column-note {
						grid-column: span 21;

						> div {
							width: 90%;
						}
					}

					&__column-id {
						grid-column: span 2;

						> div {
							width: 70%;
						}
					}
	
					&__column-1 {
						grid-column: span 1;
					}
	
					&__column-2 {
						grid-column: span 2;
					}
	
					&__column-4 {
						grid-column: span 4;
					}
	
					&__column-6 {
						grid-column: span 6;
					}
	
					&__column-8 {
						grid-column: span 8;
					}
	
					&__centered-column {
						display: flex;
						align-items: center;
					}
	
					&__column-invoice {
						grid-column: span 2;
					}
	
					&__column-total-paid {
						grid-column: span 2;
	
						&__paid {
							color: #08C547;
						}
	
						&__overpaid {
							color: #CF1414;
						}
					}
				}
			}
		}

	}

	&__delete-button {
		margin-top: Constants.$val-spacing-m;

		& > [class^="icon-delete"] {
			color: Colors.$col-grey;
			font-size: Constants.$val-fontSizeBig;
			cursor: pointer;
			margin-top: calc(Constants.$val-spacing-l + Constants.$val-spacing-s);

			&:hover {
				color: Colors.$col-black;
			}
		}
	}

	&__tab {
		display: flex;
		gap: Constants.$val-spacing-xs;
		align-items: center;

		& > [class^="icon-warning"] {
			color: Colors.$col-canceledRed;
			font-size: Constants.$val-fontSizeBig;

		}
	}

	&__add-field-button {
		width: fit-content;
		color: Colors.$col-blue;
		cursor: pointer;
		display: flex;
		align-items: center;
		margin-top: Constants.$val-spacing-m;

		& [class^="icon-plus"] {
			font-size: Constants.$val-fontSizeBig;
			margin-right: Constants.$val-spacing-s;
		}
		&:hover {
			color: Colors.$col-darkBlueBorder;
		}
	}

} 

.installments {
	&__invoiced {
		&__add_btn {
			margin-top: Constants.$val-spacing-l;
		}

		&__list {
			margin-top: Constants.$val-spacing-s;
			padding-bottom: Constants.$val-spacing-s;

			&__header {
				color: Colors.$col-greyDark;
				margin-bottom: Constants.$val-spacing-s;

				&__number {
					color: Colors.$col-design-gray5;
				}
			}

			&__items {
				padding-bottom: 20px;
			}

			&__item {
				&__actions {
					display: flex;
					align-items: center;
					justify-content: flex-end;
					font-size: Constants.$val-fontSizeBig;
					//padding-top: Constants.$val-spacing-xs;
					padding-bottom: Constants.$val-spacing-s;
					padding-right: Constants.$val-spacing-m;

					&--blue-edit {
						[class^="icon-edit"] {
							color: Colors.$col-blue;
						}
					}

					&--red-delete {
						[class^="icon-delete"] {
							color: Colors.$col-canceledRed;
						}
					}

					span {
						color: Colors.$col-design-gray6;
						cursor: pointer;

						&.disabled {
							color: Colors.$col-design-gray5;
							cursor: not-allowed;
						}

						&:not(:first-child) {
							margin-left: Constants.$val-spacing-s;
						}
					}
				}

				&__preview {
					padding-top: Constants.$val-spacing-xs;
					padding-bottom: Constants.$val-spacing-xs;

					&__number {
						color: Colors.$col-design-gray5;
					}

					&__field {
						font-weight: bold;

						&--strong {
							color: Colors.$col-greyDark;
						}

						&--invalid {
							color: Colors.$col-canceledRed !important;
						}
					}

					&__download-preview {
						//justify-content: center;
						//display: flex;
						padding-left: Constants.$val-spacing-m;
						color: Colors.$col-blue;
						font-size: Constants.$val-fontSizeBig;
					}

					&--invalid {
						background-color: Colors.$col-orangeHover;
					}
				}

				&__edit {
					&:not(:first-child) {
						margin-top: Constants.$val-spacing-s;
					}

					&__actions {
						padding-top: Constants.$val-spacing-xl;
						font-size: Constants.$val-fontSizeBig;

						&--disabled {
							[class^="icon-check"] {
								color: Colors.$col-design-gray5;
								cursor: not-allowed;
							}
						}
	
						&--red-delete {
							[class^="icon-delete"] {
								color: Colors.$col-canceledRed;
							}
						}

						span {
							color: Colors.$col-design-gray6;
							cursor: pointer;
	
							&.disabled {
								color: Colors.$col-canceledRed;
								cursor: not-allowed;
							}
	
							&:not(:first-child) {
								margin-left: Constants.$val-spacing-s;
							}
						}
					}
				}
			}
		}
	}
}

.buttonActions {
	display: flex;
	& > * + * {
		margin-left: Constants.$val-spacing-xs;
	}
}